:host {
    display: block;
}

.search {
    position: relative;
    display: flex;
    height: 40px;
    margin-bottom: 15px;

    input {
        width: 100%;
        box-sizing: border-box;
        padding: 10px 31px 10px 5px;
        max-width: 100%;
        outline: none;
        height: 40px;
        font-family: var(--primary-font);
        font-weight: var(--font-weight-regular);
        font-size: 16px;
        border: 1px solid var(--color-silver);
        border-radius: 3px;
        background-color: var(--color-white);
    }

    .clear {
        position: absolute;
        display: none;
        justify-content: center;
        align-items: center;
        top: 0px;
        right: 0px;
        width: 40px;
        height: 40px;
        cursor: pointer;

        &.show {
            display: flex;
        }
    }
}


.filter-items {
    display: flex;
    flex-direction: column;
    gap: 12px;

    .group {
        .children {
            height: 0;
            overflow: hidden;
        }

        .parent {
            display: flex;
            position: relative;

            label {
                max-width: calc(100% - 30px);
            }

            &::after {
                content: '';
                display: flex;
                height: 6px;
                width: 6px;
                align-self: flex-start;
                margin-left: 12px;
                border-right: 2px solid #959086;
                border-bottom: 2px solid #959086;
                margin-top: 6px;
                transform: rotate(45deg);
            }
        }

        &.open {
            display: flex;
            flex-direction: column;
            gap: 12px;
            .children {
                height: 100%;
                margin-left: 32px;
                display: flex;
                flex-direction: column;
                gap: 12px;
            }
            .parent::after {
                margin-top: 8.5px;
                transform: rotate(225deg);
            }
        }

        &.selected-children .parent .item-checkbox::after {
            content: '';
            top: 1px;
            left: 1px;
            width: 13px;
            height: 13px;
            background-color: var(--color-silver);
            position: absolute;
        }
    }

    label {
        cursor: pointer;
        line-height: 1;
        display: grid;
        grid-template-columns: auto 1fr;

        input {
            display: none;
        }

        .item-checkbox {
            width: 30px;
            display: inline-block;
        }

        .item-label {
            font-family: var(--primary-font);
            font-size: 18px;
            color: #959086;
            transform: translateY(2px); // fix problem with baseline in uppercase (all options starts with uppercase, 1px would be better for Firefox...)
        }

        input:checked~.item-checkbox {
            font-family: var(--primary-icon-font);
            font-size: 18px;
            color: var(--color-nero);

            &:before {
                content: '\e814';
                position: relative;
                top: 10px;
            }
        }

        input:checked~.item-label {
            color: var(--color-nero);
        }
    }

    &.scrollbar {
        height: 138px;
        overflow-y: auto;

        &::-webkit-scrollbar {
            background-color: var(--color-livique-anthrazit);
            width: 7px;
        }

        &::-webkit-scrollbar-thumb {
            background-color: var(--color-livique-anthrazit);
            border: none;
            border-radius: 5px;
        }

        &::-webkit-scrollbar-track {
            background-color: var(--color-bleached-silk);
        }

        // Firefox
        scrollbar-color: var(--color-livique-anthrazit) var(--color-bleached-silk);
        scrollbar-width: thin;
    }
}
